import React from 'react';
import { formatMarathiDate } from '../../utils/marathi';
import { LocationMap } from '../../components/maps/LocationMap';
import './DetailModal.css';

export default function FacilityDetailModal({ facility, onClose }) {
  if (!facility) return null;

  const facilityTypes = {
    hospital: '🏥 Hospital',
    health_center: '⚕️ Health Center',
    school: '🎓 School',
    college: '🏫 College',
    water_source: '💧 Water Source',
    pump: '⚙️ Pump',
    well: '🌊 Well',
    religious_site: '🏛️ Religious Site',
    community_center: '🏢 Community Center',
    library: '📚 Library',
    agricultural_facility: '🌾 Agricultural Facility',
    market: '🏬 Market',
    miscellaneous: '📦 Miscellaneous',
  };

  const availabilityOptions = {
    available: 'Available',
    business_hours: 'Business Hours',
    seasonal: 'Seasonal',
    on_demand: 'On Demand',
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{facility.name}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          {/* Basic Information */}
          <div className="modal-section">
            <h3>मूलभूत माहिती (Basic Information)</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Type:</label>
                <span>{facilityTypes[facility.facility_type] || facility.facility_type}</span>
              </div>
              <div className="detail-item">
                <label>Status:</label>
                <span className={facility.is_active ? 'status-active' : 'status-inactive'}>
                  {facility.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
            {facility.description && (
              <div className="detail-item full-width">
                <label>Description:</label>
                <p>{facility.description}</p>
              </div>
            )}
          </div>

          {/* Location & Contact */}
          <div className="modal-section">
            <h3>स्थान व संपर्क (Location & Contact)</h3>
            <div className="detail-grid">
              {facility.address && (
                <div className="detail-item">
                  <label>Address:</label>
                  <p>{facility.address}</p>
                </div>
              )}
              {facility.phone && (
                <div className="detail-item">
                  <label>Phone:</label>
                  <span>{facility.phone}</span>
                </div>
              )}
              {facility.email && (
                <div className="detail-item">
                  <label>Email:</label>
                  <span>{facility.email}</span>
                </div>
              )}
              {facility.opening_hours && (
                <div className="detail-item">
                  <label>Hours:</label>
                  <span>{facility.opening_hours}</span>
                </div>
              )}
            </div>
          </div>

          {/* Operating Information */}
          {(facility.availability || facility.latitude || facility.longitude) && (
            <div className="modal-section">
              <h3>तांत्रिक माहिती (Technical Information)</h3>
              <div className="detail-grid">
                {facility.availability && (
                  <div className="detail-item">
                    <label>Availability:</label>
                    <span>{availabilityOptions[facility.availability] || facility.availability}</span>
                  </div>
                )}
              </div>
              <LocationMap latitude={facility.latitude} longitude={facility.longitude} title={facility.name} address={facility.address} compact />
            </div>
          )}

          {/* In-Charge Information */}
          {(facility.in_charge_name || facility.in_charge_phone) && (
            <div className="modal-section">
              <h3>जबाबदार व्यक्ती (In-Charge Person)</h3>
              <div className="detail-grid">
                {facility.in_charge_name && (
                  <div className="detail-item">
                    <label>Name:</label>
                    <span>{facility.in_charge_name}</span>
                  </div>
                )}
                {facility.in_charge_phone && (
                  <div className="detail-item">
                    <label>Phone:</label>
                    <span>{facility.in_charge_phone}</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Additional Details */}
          {facility.additional_details && Object.keys(facility.additional_details).length > 0 && (
            <div className="modal-section">
              <h3>अतिरिक्त विवरण (Additional Details)</h3>
              <div className="details-json">
                {Object.entries(facility.additional_details).map(([key, value]) => (
                  <div key={key} className="detail-item">
                    <label>{key.replace(/_/g, ' ')}:</label>
                    <span>{typeof value === 'object' ? JSON.stringify(value) : String(value)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Metadata */}
          <div className="modal-section">
            <h3>माहिती (Metadata)</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Created:</label>
                <span>{formatMarathiDate(facility.created_at)}</span>
              </div>
              <div className="detail-item">
                <label>Updated:</label>
                <span>{formatMarathiDate(facility.updated_at)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
